import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AccentTextButton } from '@/components/AccentTextButton';
import { useAuth } from './AuthContext';
import { adminLogout, getAdminUser } from '@/modules/admin/api';
import styles from './ForgotPasswordAction.module.css';

/** Leave the current session before entering the existing password-reset flow. */
export function ForgotPasswordAction({ email, admin = false, className, disabled }: {
  email?: string; admin?: boolean; className?: string; disabled?: boolean;
}) {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  async function beginReset() {
    if (busy) return;
    setBusy(true);
    const resetEmail = email ?? (admin ? getAdminUser()?.email : user?.email) ?? '';
    try {
      if (admin) await adminLogout();
      else await signOut();
      navigate(`${admin ? '/admin/login' : '/login'}?mode=forgot`, {
        replace: true,
        state: { resetEmail },
      });
    } finally { setBusy(false); }
  }
  return <AccentTextButton arrow className={`${styles.action} ${className ?? ''}`} onClick={beginReset} disabled={busy || disabled}>
    {busy ? 'Signing out…' : 'Forgot your password?'}
  </AccentTextButton>;
}
